import DeviceDetector from '@/plugins/device-detector'

export default {
  data () {
    return {
      rootIsSmartphone: false,
      rootIsMobile: false,
      rootIsWindows: false,
      rootVueHeadViewport: false
    }
  },
  watch: {
    '$route': {
      handler () {
        document.title = this.$route.meta.title
      },
      immediate: true
    }
  },
  computed: {
  },
  methods: {
    checkDevice () {
      this.rootIsSmartphone = DeviceDetector.isSmartphone
      this.rootIsMobile = DeviceDetector.isMobile
      this.rootIsWindows = DeviceDetector.isWindows
      this.rootIsIOS = DeviceDetector.isIOS
      this.rootVueHeadViewport = this.rootIsSmartphone
        ? 'width=320,user-scalable=no,target-densitydpi=device-dpi'
        : 'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,shrink-to-fit=no'
    }
  },
  head: {
    meta () {
      return [
        { name: 'viewport', content: this.rootVueHeadViewport }
      ]
    }
  },
  created () {
    this.checkDevice()

    if (this.rootIsMobile) {
      document.documentElement.classList.add('touch')
    }
    // for scrollbar fix
    if (this.rootIsWindows) {
      document.documentElement.classList.add('win')
    }
    // for mobile version
    if (this.rootIsSmartphone) {
      document.documentElement.classList.add('smartphone')
    }
    // for mobile version
    if (this.rootIsIOS) {
      document.documentElement.classList.add('ios')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/root.js